import { put, call } from "redux-saga/effects";

import axios from "../../services/axios-service";
import * as actions from "../actions";
import ConsoleLog from "../../hoc/ConsoleLog/ConsoleLog";
import getS3ImageUrl from "../../lib/s3FileHandler";

/**
 * @desc saga for candidate profile
 * @version
 * @author Lakshmikanth
 * @return api response
 */
export function* getProfileDetailsSaga(action) {
  var client = action.isClient ? "&isClient=1" : "&isClient=0";
  try {
    const response = yield axios.get(
      "/galaxy/job/" +
        action.jobTitleId +
        "/candidate/" +
        action.candidateId +
        "?" +
        client
    );
    if (response.data.item.candidate_image) {
      const candidateImageResponse = yield call(
        getS3ImageUrl,
        response.data.item.candidate_image,
        action.user
      );
      response.data.item.s3SignedUrl = candidateImageResponse;
    }
    yield put(
      actions.setCandidateProfile(
        response.data.item ? response.data.item : response.data
      )
    );
  } catch (error) {
    ConsoleLog(error);
  }
}

export function* updateCandidateStatusSaga(action) {
  const data = {
    candidateId: action.candidateId,
    jobId: action.jobId,
    status: action.status,
    regretReason: action.regretReason,
    scoredBy: action.scoredBy,
    scoredByName: action.scoredByName,
    prevStatus: action.prevStatus
  };
  //ConsoleLog("prevStatus",action.prevStatus)
  try {
    const response = yield axios.post(
      "/galaxy/job/" + action.jobId + "/candidate/" + action.candidateId,
      JSON.stringify(data)
    );
    if (!action.isReviewAll) {
      yield put(
        actions.setStatus(
          data.candidateId,
          data.status,
          action.score,
          action.totalScore
        )
      );
    }
  } catch (error) {
    ConsoleLog(error);
  }
}

export function* getProfileDetailsRecruiterSaga(action) {
  try {
    const response = yield axios.get(
      "/galaxy/job/" + action.jobTitleId + "/candidate/" + action.candidateId        
    );
    yield put(actions.setCandidateProfile(response.data.item));
  } catch (error) {
    ConsoleLog(error);
  }
}

export function* updateCandidateProfileImageSaga(action) {
  try {
    const response =
      action.candidateImage !== null
        ? yield call(getS3ImageUrl, action.candidateImage, action.user)
        : null;
    yield put(
      actions.setCandidateProfileImage(response, action.candidateImage)
    );
    yield put(
      actions.setCandidateCardProfileImage(
        response,
        action.candidateId,
        action.candidateImage
      )
    );
  } catch (error) {
    ConsoleLog(error);
  }
}



// WEBPACK FOOTER //
// ./src/store/sagas/candidateProfile.js